import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function CarCard({ car, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group relative bg-zinc-900/40 border border-zinc-800/50 rounded-xl overflow-hidden backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-500"
    >
      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/40 to-transparent z-10 pointer-events-none" />

      <div className="relative h-56 overflow-hidden">
        <div className="absolute inset-0 bg-cyan-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 mix-blend-overlay" />
        <img
          src={car.image}
          alt={car.name}
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 grayscale-[0.3] group-hover:grayscale-0"
        />
        <div className="absolute top-4 left-4 z-20 px-3 py-1 bg-zinc-950/80 border border-amber-500/30 backdrop-blur-md rounded text-[10px] font-bold tracking-widest text-amber-400 uppercase">
          {car.class}
        </div>
      </div>

      <div className="relative z-20 p-6 -mt-8">
        <h3 className="text-2xl font-black uppercase tracking-tight text-zinc-100 mb-2 group-hover:text-glow-cyan transition-all">
          {car.name}
        </h3>
        <p className="text-xs text-zinc-400 mb-6 min-h-[32px] leading-relaxed">
          {car.description}
        </p>

        <div className="grid grid-cols-3 gap-2 mb-6">
          <div className="bg-zinc-950/50 p-2 rounded border border-zinc-800/50 text-center">
            <div className="text-[9px] text-zinc-500 uppercase tracking-wider mb-1">SPD</div>
            <div className="text-sm font-mono text-cyan-400">{car.stats.speed}</div>
          </div>
          <div className="bg-zinc-950/50 p-2 rounded border border-zinc-800/50 text-center">
            <div className="text-[9px] text-zinc-500 uppercase tracking-wider mb-1">HND</div>
            <div className="text-sm font-mono text-cyan-400">{car.stats.handling}</div>
          </div>
          <div className="bg-zinc-950/50 p-2 rounded border border-zinc-800/50 text-center">
            <div className="text-[9px] text-zinc-500 uppercase tracking-wider mb-1">CORE</div>
            <div className="text-sm font-mono text-fuchsia-400">{car.stats.aiCore}</div>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-lg font-mono text-zinc-300">
            <span className="text-zinc-600 text-xs mr-1">CR</span>
            {car.basePrice.toLocaleString()}
          </div>
          <Link
            to={`/build/${car.id}`}
            className="px-4 py-2 bg-amber-500/10 border border-amber-500/50 text-amber-400 text-xs font-bold uppercase tracking-wider rounded hover:bg-amber-500 hover:text-zinc-950 transition-all flex items-center gap-2"
          >
            Config <SafeIcon icon={FiIcons.FiSettings} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}